<template>
  <div id="app">
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report (Samsung User)</div>
    <IssueReport></IssueReport>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report (Development User)</div>
    <IssueReportDevelopmentUser></IssueReportDevelopmentUser>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report Development Name</div>
    <IssueReportDevelopmentName></IssueReportDevelopmentName>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report Development Name Model Grouping</div>
    <IssueReportDevelopmentNameModelGrouping></IssueReportDevelopmentNameModelGrouping>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report Development Name Issue No (Samsung User)</div>
    <IssueReportDevelopmentNameIssueNo></IssueReportDevelopmentNameIssueNo>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report Development Name Issue No (Developer User)</div>
    <IssueReportDevelopmentNameIssueNoDeveloperUser></IssueReportDevelopmentNameIssueNoDeveloperUser>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report Package Name Create</div>
    <IssueReportPackageNameCreate></IssueReportPackageNameCreate>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Issue Report Package Name Create Done</div>
    <IssueReportPackageNameCreateDone></IssueReportPackageNameCreateDone>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Automated Test History</div>
    <AutomatedTestHistory></AutomatedTestHistory>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Diagnostic Test</div>
    <DiagnosticTest></DiagnosticTest>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Diagnostic Test Done</div>
    <DiagnosticTestDone></DiagnosticTestDone>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Diagnostic Test History</div>
    <DiagnosticTestHistory></DiagnosticTestHistory>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Diagnostic Test Result</div>
    <DiagnosticTestResult></DiagnosticTestResult>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Administrator Application List</div>
    <AdministratorApplicationList></AdministratorApplicationList>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Administrator Register Application</div>
    <AdministratorRegisterApplication></AdministratorRegisterApplication>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Administrator Issue Report Data Upload</div>
    <AdministratorIssueReportDataUpload></AdministratorIssueReportDataUpload>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Administrator Diagnostic Test Data Upload</div>
    <AdministratorDiagnosticTestDataUpload></AdministratorDiagnosticTestDataUpload>
    -------------------------------------------------
    <popupContent></popupContent>
    
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Docs User Manual Chapter1</div>
    <DocsUserManualChapter1></DocsUserManualChapter1>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Docs User Manual Chapter2</div>
    <DocsUserManualChapter2></DocsUserManualChapter2>
    -------------------------------------------------
    <div style="margin: 30px 0; font-size: 50px; text-align: center; color: #777;">Automated Test Result</div>
    <AutomatedTestResult></AutomatedTestResult>
    -------------------------------------------------
  </div>
</template>

<script>
  import IssueReport from './components/IssueReport.vue';
  import IssueReportDevelopmentUser from './components/IssueReportDevelopmentUser.vue';
  import IssueReportDevelopmentName from './components/IssueReportDevelopmentName.vue';
  import IssueReportDevelopmentNameModelGrouping from './components/IssueReportDevelopmentNameModelGrouping.vue';
  import IssueReportDevelopmentNameIssueNo from './components/IssueReportDevelopmentNameIssueNo.vue';
  import IssueReportDevelopmentNameIssueNoDeveloperUser from './components/IssueReportDevelopmentNameIssueNoDeveloperUser.vue';
  import IssueReportPackageNameCreate from './components/IssueReportPackageNameCreate.vue';
  import IssueReportPackageNameCreateDone from './components/IssueReportPackageNameCreateDone.vue';
  import AutomatedTestHistory from './components/AutomatedTestHistory.vue';
  import DiagnosticTest from './components/DiagnosticTest.vue';
  import DiagnosticTestDone from './components/DiagnosticTestDone.vue';
  import DiagnosticTestHistory from './components/DiagnosticTestHistory.vue';
  import DiagnosticTestResult from './components/DiagnosticTestResult.vue';
  import AdministratorApplicationList from './components/AdministratorApplicationList.vue';
  import AdministratorRegisterApplication from './components/AdministratorRegisterApplication.vue';
  import AdministratorIssueReportDataUpload from './components/AdministratorIssueReportDataUpload.vue';
  import AdministratorDiagnosticTestDataUpload from './components/AdministratorDiagnosticTestDataUpload.vue';
  import popupContent from './components/popupContent.vue';
  import DocsUserManualChapter1 from './components/DocsUserManualChapter1.vue';
  import DocsUserManualChapter2 from './components/DocsUserManualChapter2.vue';
  import AutomatedTestResult from './components/AutomatedTestResult.vue';

  export default {
    name: 'App',
    components: { 
      IssueReport, IssueReportDevelopmentUser, IssueReportDevelopmentName, IssueReportDevelopmentNameModelGrouping, IssueReportPackageNameCreate, IssueReportDevelopmentNameIssueNo, IssueReportDevelopmentNameIssueNoDeveloperUser, IssueReportPackageNameCreateDone, 
      AutomatedTestHistory, 
      DiagnosticTest, DiagnosticTestDone, DiagnosticTestHistory, DiagnosticTestResult,
      AdministratorApplicationList, AdministratorRegisterApplication, AdministratorIssueReportDataUpload, AdministratorDiagnosticTestDataUpload,
      popupContent,
      DocsUserManualChapter1, DocsUserManualChapter2,
      AutomatedTestResult
    },
  }
</script>

<style>
  @import './assets/css/font.css';
</style>
<style>
  @import './assets/css/default.css';
</style>
<style>
  @import './assets/css/jquery-ui.min.css';
</style>
